import { requestPermutations } from '@global/api/data-generation'
import { useMutation } from '@tanstack/react-query'
import { useMemo, useRef } from 'react'

const MAX_PERMUTATIONS = 2000

export const useRequestPermutations = () => {
  const sessionIdRef = useRef<string>()
  const { mutate, reset, error, isSuccess, isPending, data } = useMutation({
    mutationFn: requestPermutations,
    onSuccess: data => {
      sessionIdRef.current = data.sessionId
    },
  })

  return useMemo(
    () => ({
      requestPermutations: mutate,
      resetRequestPermutations: reset,
      isRequestPermutationsSuccess: isSuccess,
      isRequestPermutationsError: error,
      isRequestPermutationsLoading: isPending,
      exceedsMaxPermutations: (data?.rowCount ?? 0) > MAX_PERMUTATIONS,
      sessionId: sessionIdRef.current,
      generatedFields: data?.fields ?? [],
      excludedFields: data?.excludedFields ?? [],
      unsupportedFields: data?.unsupportedFields ?? [],
      readOnlyFields: data?.readOnlyFields ?? [],
    }),
    [data, mutate, reset, error, isSuccess, isPending],
  )
}
